<template>
  <div class="chart-axis-label" :class="getAxisLabel">
    <div class="axis-label-holder" :class="getHolderSideClass">
      <div class="axis-label" :class="getSideClass">
        <div>{{ label }}</div>
      </div>
    </div>
    <div class="axis-line-holder" id="axisLineHolder" :class="getAxisLineHolder" >
      <div v-if="validInputs" class="axis-lines">
        <svg ref="chartAxisLabel" width="100%" height="100%">
          <YAxisLines :side="side"/>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import YAxisLines from '@/components/layout/pressure_flow_chart/pressure_flow_chart_components/YAxisLines';
import { useInputStore } from '@/store/InputStore';
import { usePrintStore } from '@/store/PrintStore';

export default {
  name: 'ChartAxisLabel',
  components: {
    YAxisLines
  },
  mounted () {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
    const resizeObserver = new ResizeObserver(this.handleResize);
    resizeObserver.observe(document.getElementById('pressureFlowChart'));
  },
  unmounted () {
    window.removeEventListener('resize', this.handleResize);
  },
  watch : {
    printCancel: {
      handler () {
        this.handleResize();
      }
    }
  },
  props: [
    'side',
    'label'
  ],
  computed: {
    validInputs () {
      return useInputStore().validInputs;
    },
    printCancel () {
      return usePrintStore().getPrintIsOpen;
    },
    getHolderSideClass () {
      return this.side === 'left' ? '' : 'right-holder-side';
    },
    getSideClass () {
      return this.side === 'left' ? 'left-side' : 'right-side';
    },
    getAxisLineHolder () {
      return this.side === 'left' ? 'left-axis-line-holder' : 'right-axis-line-holder';
    },
    getAxisLabel () {
      return this.side === 'left' ? 'chart-axis-label-right' : 'chart-axis-label-left';
    },
  },
  methods: {
    handleResize () {
      if (!this.$refs.chartAxisLabel) {
        return;
      }
      useInputStore().setChartAxisLabelWidth(this.$refs.chartAxisLabel.clientWidth);
    },
  }
};
</script>

<style scoped>
.axis-label-holder {
  position: absolute;
  top:0;
  height: 100%;
  display: flex;
  align-items: center;
}
.right-holder-side {
  justify-content: flex-end;
  right: 0;
}
.axis-label {
  color: white;
  height: 180px;
  padding: 2px;
  text-align: center;
  user-select: none;
  writing-mode: vertical-lr;
}
.left-side {
  background-color: var(--pressure-color);
  transform: rotate(180deg);
  margin-left: 8px;
}
.right-side {
  background-color: var(--flow-color);
  justify-self: flex-end;
  margin-right: 8px;
}
.axis-line-holder {
  position: absolute;
  top:0;
  left: 0;
  right: 0;
  height: 100%;
}
.chart-axis-label {
  width: 10%;
  position: relative;
  min-width: 80px;
}
.axis-lines {
  height: 100%;
  pointer-events: none;
}
.left-axis-line-holder {
  border-right: .5px solid #9f9f9f;
}
.right-axis-line-holder {
  border-left: .5px solid #9f9f9f;
}
</style>